//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

import StatisticsTradeTurnoverP2P from './StatisticsTradeTurnoverP2P/StatisticsTradeTurnoverP2P.vue';
import StatisticsTradeTransactions from './StatisticsTradeTransactions/StatisticsTradeTransactions.vue';

export default {
  components: { StatisticsTradeTurnoverP2P, StatisticsTradeTransactions },
};
